<template>
  <div class="part-container">
    <!-- 头部 -->
    <div class="part-header">
      <div class="header-title">相关美图</div>
      <!-- 将更多按钮移到头部标题右侧 -->
      <button 
        v-if="totalInPage > 6" 
        class="more-button"
        @click="handleAddClick"
      >
        + 更多
      </button>
    </div>

    <!-- 内容区域 -->
    <div class="images-content">
      <!-- 图片网格 -->
      <div class="images-grid" :class="{ 'no-data': !displayImages || displayImages.length === 0 }">
        <!-- 有图片数据时显示图片 -->
        <template v-if="displayImages && displayImages.length > 0">
          <div
            v-for="(image, index) in gridImages"
            :key="index"
            class="image-item"
            @click="handleImageClick(image, index)"
          >
            <div class="image-wrapper">
              <img :src="image.ossKey" :alt="image.title" class="image">
              <div class="image-overlay">
                <div class="image-name">{{ image.customName }}</div>
              </div>
            </div>
          </div>
        </template>
        
        <!-- 无图片数据时显示整体占位符 -->
        <div v-else class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-pic.png" alt="暂无图片" class="no-data-image" />
          <p class="no-data-text">暂无图片内容</p>
        </div>
      </div>
    </div>

    <!-- 自定义 图片预览弹窗 -->
    <div class="image-preview-cover" v-if="previewVisible">
      <div class="pop">
          <div class="caption-left">{{ previewImage.customName }}</div>
        <div class="pop-video">
      
          <img
            v-if="previewImage.ossKey"
            ref="previewImageEl"
            class="preview-image"
            :src="previewImage.ossKey"
            :alt="previewImage.customName || '图片预览'"
          />


     <img
          class="error-icon"
          src="/assets/~/media/images/icon/close-white.png"
          alt="关闭"
          @click="handlePreviewClose"
        >
          <!-- 底部信息与导航 -->
          <div class="caption-bar"> 
            <div class="caption-right">
              <button class="nav-btn prev" :disabled="disablePrev" @click.stop="showPrev" aria-label="上一张">‹</button>
              <span class="counter">{{ displayIndex }}/{{ totalInPagePadded }}</span>
              <button class="nav-btn next" :disabled="disableNext" @click.stop="showNext" aria-label="下一张">›</button>
            </div>
          </div>
        </div>
      
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'DetailImages',
  props: {
    // 图片数据列表
    images: {
      type: Array,
      default: () => [],
    },
    // 行数：1 或 2
    rows: {
      type: Number,
      default: 1,
      validator: (value) => value === 1 || value === 2,
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1,
    },
    // 每页数量（父组件以 page-size 传入）
    pageSize: {
      type: Number,
      default: 100,
    },
    // 总图片数量
    totalImages: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: {
        ossKey: '',
        customName: '',
      },
      currentIndex: 0,
      gridLimit: 6, // 修改为最多显示6张图片
      zoomLevel: 1, // 新增：图片缩放级别
    };
  },
  computed: {
    // 总页数
    totalPages() {
      return Math.ceil(this.totalImages / this.pageSize);
    },
    // 当前显示的图片
    displayImages() {
      return this.images;
    },
    // 网格内展示的图片（前 6 张）
    gridImages() {
      return (this.displayImages || []).slice(0, 6);
    },
    // 本页总数
    totalInPage() {
      return (this.displayImages && this.displayImages.length) || 0;
    },
    // 显示索引（两位数）
    displayIndex() {
      const idx = this.currentIndex + 1;
      return String(idx).padStart(2, '0');
    },
    // 本页总数（两位数）
    totalInPagePadded() {
      return String(this.totalInPage).padStart(2, '0');
    },
    // 禁用上一张
    disablePrev() {
      return this.currentIndex <= 0 || this.totalInPage <= 0;
    },
    // 禁用下一张
    disableNext() {
      return this.totalInPage <= 0 || this.currentIndex >= this.totalInPage - 1;
    },
  },
  methods: {
    // 处理分页变化
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
    // 处理图片点击
    handleImageClick(image, index) {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关美图-第'+ (index+1) + '张图片', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关美图-第'+ (index+1) + '张图片');

      this.currentIndex = index;
      this.previewImage = {
        ossKey: image.ossKey,
        customName: image.customName || '',
      };
      this.zoomLevel = 1; // 重置缩放级别
      this.previewVisible = true;
      this.$emit('image-click', image);
    },
    // 点击更多按钮：从第 1 张开始预览
    handleAddClick() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关美图-“+”查看更多', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关美图-“+”查看更多');

      this.currentIndex = 0; // 从第一张开始预览
      this.zoomLevel = 1; // 重置缩放级别
      this.updatePreviewByIndex();
      this.previewVisible = true;



        if (this.images.length > 6) {

        this.currentIndex = 6; // 从第7个视频开始（索引为6）
        this.zoomLevel = 1; // 重置缩放级别
        this.updatePreviewByIndex();
        this.previewVisible = true;
      }
    },
    // 根据索引更新预览
    updatePreviewByIndex() {
      if (!this.totalInPage) return;
      const clamped = Math.max(0, Math.min(this.currentIndex, this.totalInPage - 1));
      this.currentIndex = clamped;
      const img = this.displayImages[clamped] || {};
      this.previewImage = {
        ossKey: img.ossKey || '',
        customName: img.customName || '',
      };
      this.zoomLevel = 1; // 切换图片时重置缩放级别
    },
    // 上一张
    showPrev() {
      if (!this.totalInPage || this.disablePrev) return;
      this.currentIndex = this.currentIndex - 1;
      this.updatePreviewByIndex();
    },
    // 下一张
    showNext() {
      if (!this.totalInPage || this.disableNext) return;
      this.currentIndex = this.currentIndex + 1;
      this.updatePreviewByIndex();
    },
    // 关闭预览
    handlePreviewClose() {
      this.previewVisible = false;
      this.previewImage = { ossKey: '', customName: '' };
      this.currentIndex = 0;
      this.zoomLevel = 1; // 关闭预览时重置缩放级别
    },
    // 新增：图片放大
    zoomIn() {
      if (this.zoomLevel < 3) { // 设置最大缩放倍数为3
        this.zoomLevel += 0.1;
      }
    },
    // 新增：图片缩小
    zoomOut() {
      if (this.zoomLevel > 0.5) { // 设置最小缩放倍数为0.5
        this.zoomLevel -= 0.1;
      }
    },
    // 新增：重置缩放
    resetZoom() {
      this.zoomLevel = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 移动端优先设计，所有样式均基于375px基准进行动态计算 */
@import './style/part.css';

/* 容器样式 */
.part-container {
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
  padding: calc(15 / 375 * 100vw);
  box-sizing: border-box;
  overflow-y: auto;
}

/* 头部样式 */
.part-header {
  height: calc(44 / 375 * 100vw);
  margin-bottom: calc(15 / 375 * 100vw);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.header-title {
  color: #333333;
  font-size: calc(18 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-B-GB';
  padding-top: 0;
}

/* 更多按钮样式 */
.more-button {
  background: #F5F7FA;
  border: 1px solid #F5F7FA;
  border-radius: calc(20 / 375 * 100vw);
  color: #37434C;
  padding: calc(8 / 375 * 100vw) calc(16 / 375 * 100vw); 
  font-size: calc(12 / 375 * 100vw);
  cursor: pointer;
  transition: all 0.3s ease;
}

.more-button:active {
  background: #E4E7ED;
  border-color: #DCDFE6;
}

/* 内容区域 */
.images-content {
  width: 100%;
}

/* 图片网格样式 */
.images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: calc(8 / 375 * 100vw);
  margin-bottom: calc(15 / 375 * 100vw);
  border-radius: 0;
  align-items: stretch;
}

/* 无数据时的整体占位符样式 */
.images-grid.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 0;
  width: 100%;
  aspect-ratio: 66 / 48;
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.no-data-image {
  width: calc(80 / 375 * 100vw);
  height: calc(60 / 375 * 100vw);
  margin-bottom: calc(10 / 375 * 100vw);
  opacity: 0.5;
  object-fit: contain;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(14 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}

/* 图片项样式 */
.image-item {
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
  aspect-ratio: 66 / 48;
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-radius: calc(8 / 375 * 100vw);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

/* 图片覆盖层 */
.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: calc(8 / 375 * 100vw);
  opacity: 1;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  transition: opacity 0.3s ease;
}

.image-name {
  color: #fff;
  font-size: calc(12 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  line-height: 1.3;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

/* 触摸反馈效果 */
.image-wrapper:active .image {
  transform: scale(1.05);
}

/* 预览弹窗 */
.image-preview-cover {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;
  align-items: center;
  justify-content: center;
}

.pop {
  display: flex;
  flex-direction: column;
  width: 100%;
  // max-width: 90%;
}

.pop-video {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image {
  width: calc(100% - 40 / 375 * 100vw);
  // margin-left: calc(20 / 375 * 100vw);
  height: auto;
  max-height: 70vh;
  object-fit: contain;
  background: #000;
}

.error-icon {
  position: absolute;
  top: calc(0 / 375 * 100vw);
  right: calc(0 / 375 * 100vw);
  width: calc(24 / 375 * 100vw + 32 / 375 * 100vw);
  height: calc(24 / 375 * 100vw + 32 / 375 * 100vw);
  padding: calc(16 / 375 * 100vw);
  z-index: 10;
}

/* 底部信息与导航 */
.caption-bar {
  position: absolute;
  bottom: calc(60 / 375 * 100vw);
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(15 / 375 * 100vw) calc(40 / 375 * 100vw);
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  pointer-events: none;
}

.caption-left {
  position: absolute;
  top: calc(20 / 375 * 100vw);
  color: #fff;
  font-size: calc(16 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-B-GB';
  line-height: 1.4;
  pointer-events: auto;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  max-width: calc(100% - 40 / 375 * 100vw);
  margin-left: calc(20 / 375 * 100vw);
  margin-top: calc(40 / 375 * 100vw);
  word-wrap: break-word;
  text-align: left;
  align-self: center;
  margin-right: calc(20 / 375 * 100vw);
}

.caption-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(10 / 375 * 100vw);
  width: 100%;
  pointer-events: auto;
}

.counter {
  color: rgba(255, 255, 255, 1);
  font-size: calc(14 / 375 * 100vw);
  margin: 0 calc(8 / 375 * 100vw);
}

.nav-btn {
  width: calc(48 / 375 * 100vw);
  height: calc(48 / 375 * 100vw);
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.3);
  color: #000000;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.nav-btn:active {
  background-color: rgba(255, 255, 255, 0.5);
}

.nav-btn:disabled {
  background-color: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
}

/* 滚动条样式 */
.part-container::-webkit-scrollbar {
  width: calc(4 / 375 * 100vw);
}

.part-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: calc(2 / 375 * 100vw);
}

.part-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: calc(2 / 375 * 100vw);
}

/* 基础PC端样式 - 保持最小化，确保内容不被隐藏 */
@media (min-width: 768px) {
  .part-container {
    width: 100%;
    padding: 20px;
  }
  
  .images-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  .image-preview-cover {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
}
</style>